import env from '@beam-australia/react-env';
import {
  ErrorBoundary as SentryErrorBoundary,
  init as sentryInit,
} from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { LastLocationProvider } from 'react-router-last-location';
import { Integrations } from '@sentry/tracing';
import Amplify from 'aws-amplify';
import store from '@/rdx/store';
import App from './App';
import awsconfig from './aws-exports';
import * as serviceWorker from './serviceWorker';
import '@/lib/axios/axiosInterceptors';
import 'react-phone-input-2/lib/material.css';
import '@/styles/tailwind.css';

sentryInit({
  dsn: process.env.NODE_ENV === 'production' ? env('SENTRY_DSN') : null,
  integrations: [new Integrations.BrowserTracing()],
  environment: env('SENTRY_ENV'),
  tracesSampleRate: 1.0,
});

Amplify.configure(awsconfig);

ReactDOM.render(
  <SentryErrorBoundary fallback={<div>An error has occurred</div>} showDialog>
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <LastLocationProvider>
            <App />
          </LastLocationProvider>
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  </SentryErrorBoundary>,
  document.getElementById('root'),
);

// Allows for access to the store in cypress tests.
if (window.Cypress) {
  window.store = store;
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
